import React from "react";
import { FaChartBar, FaUsers, FaShoppingCart } from "react-icons/fa";
import "./analyticsCards.css";

const AnalyticsCards = () => {
  return (
    <div className="analytics-cards-container">
      <div className="analytics-card" style={{ background: "#4b35d3" }}>
        <div className="card-info">
          <p className="card-title">Today Sales</p>
          <p className="card-value">45</p>
        </div>
        <FaChartBar className="card-icon" />
      </div>

      <div className="analytics-card" style={{ background: "#4b4b4b" }}>
        <div className="card-info">
          <p className="card-title">Visitors</p>
          <p className="card-value">80</p>
        </div>
        <FaUsers className="card-icon" />
      </div>

      <div className="analytics-card" style={{ background: "#e65100" }}>
        <div className="card-info">
          <p className="card-title">Orders</p>
          <p className="card-value">51</p>
        </div>
        <FaShoppingCart className="card-icon" />
      </div>
    </div>
  );
};

export default AnalyticsCards;
